import gql from 'graphql-tag';

import { getSingleProp } from 'src/lib/graphql';
import { executeGqlQuery } from 'src/graphql/client';
import { FRAGMENT_TEXT_ANNOTATION } from 'src/graphql/annotation';

const QUERY = gql`
  query CurrentUserSampleTalkingPoints {
    me {
      id
      sampleTalkingPoints {
        ...TextAnnotation
      }
    }
  }
  ${FRAGMENT_TEXT_ANNOTATION}
`;

export const queryCurrentUserSampleTalkingPoints = (options) => {
  return executeGqlQuery({
    query: QUERY,
    options,
  }).then(({ data }) => getSingleProp(data));
};
